import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { HeaderHat } from '../../primitives/HeaderBlock/HeaderBlock.styles'
import {
  SplitScreenWrapper,
  TextWrapper,
  ImgWrapper,
  SplitScreenOuter,
  GraphicHead,
} from './SplitScreen.styles'

const SplitScreen = ({
  reverse,
  graphic,
  graphicComponent,
  head,
  sub,
  gWidth,
  gHeight,
  children,
  pad,
  first,
  full,
  textColor,
  innerMiddle,
  innerMax,
  textMax,
  textComponent,
  subHead,
  noHat,
  noGraphicMobile,
  caption,
  graphicHeadComponent,
}) => (
  <SplitScreenOuter>
    <SplitScreenWrapper
      pad={pad}
      reverse={reverse}
      first={first}
      innerMiddle={innerMiddle}
      innerMax={innerMax}
    >
      {textComponent ? (
        <TextWrapper
          textMax={textMax}
          textColor={textColor}
          className={reverse ? 'split-right' : ''}
          first={first}
          full={full}
        >
          {textComponent}
        </TextWrapper>
      ) : (
        <TextWrapper
          textMax={textMax}
          textColor={textColor}
          className={reverse ? 'split-right' : ''}
          first={first}
          full={full}
        >
          {!noHat && <HeaderHat />}
          {subHead && <p className="subHead">{subHead}</p>}
          <h3>{head}</h3>
          <p>{sub}</p>
          {children}
        </TextWrapper>
      )}

      <ImgWrapper
        className={!reverse ? 'split-right' : ''}
        maxW={gWidth}
        maxH={gHeight}
        noGraphicMobile={noGraphicMobile}
      >
        {!!graphicHeadComponent && (
          <GraphicHead>
            <div>
              <GatsbyImage image={graphicHeadComponent.img} alt="" />
            </div>

            <p>{graphicHeadComponent.text}</p>
          </GraphicHead>
        )}
        {graphic ? <GatsbyImage image={graphic} alt="" /> : graphicComponent}
        {!!caption && <p>{caption}</p>}
      </ImgWrapper>
    </SplitScreenWrapper>
  </SplitScreenOuter>
)

export default SplitScreen
